
import React from "react";
import { Logout } from "react-admin";

export const LogoutButton = () => {
  return (
    <Logout redirectTo="/logout" />
  );
};
